// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b
import React from 'react';

const StyledPrizeLeft = styled.div`
  background: url(${prizeLeft}) no-repeat;
  background-size: 100% 100%;
  margin-left: 5px;
  width: 100%;
  height: 80.26px;
  justify-content: start;
  display: flex;
  align-items: center;
  @media screen and (max-width: 768px) {
    background-size: 99% 45px !important;
    width: 100%;
    height: 45px;
  }
`;

const StyledPrizeRight = styled.div`
  background: url(${prizeRight}) no-repeat;
  background-size: 100% 100%;
  margin-right: 5px;
  width: 100%;
  height: 80.26px;
  justify-content: start;
  display: flex;
  align-items: center;
  display: flex;
  justify-content: space-around;
`;
const StyledSpan = styled.span`
  font-size: ${(props) => (props.length ? 20 - props.length + 'px' : '20px')};
`;

const WidthLeft = styled.div`
  width: ${(props) => (props.isLength ? '60%' : '75%')};
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;
const WidthRight = styled.div`
  width: ${(props) => (props.isLength ? '40%' : '35%')};
`;

import { useTranslation } from 'react-i18next';
import { setBackGroundLineUp } from '../../../utils/setBackGroundLineUp';
import { QUANTITY_PRIZE, RANK_NAME } from '../../../constants';
import styled from 'styled-components';
import {
  dottedLineupHeader,
  newRankA,
  newRankB,
  newRankC,
  newRankD,
  newRankE,
  newRankF,
  newRankG,
  prizeLeft,
  prizeRight,
} from '../../../../assets/imgs';

function LineUpHeader(props) {
  const { t } = useTranslation();
  const { prizeGroup, quantityPrize } = props;

  const showImageRank = (rankName) => {
    switch (rankName) {
      case RANK_NAME.rankA:
        return newRankA;
      case RANK_NAME.rankB:
        return newRankB;
      case RANK_NAME.rankC:
        return newRankC;
      case RANK_NAME.rankD:
        return newRankD;
      case RANK_NAME.rankE:
        return newRankE;
      case RANK_NAME.rankF:
        return newRankF;
      case RANK_NAME.rankG:
        return newRankG;
      default:
        return newRankA;
    }
  };

  return (
    <div className={`my-line-up-header`}>
      <div className="my-line-up-content">
        <WidthLeft
          isLength={
            prizeGroup.total_quantity.toString().length +
              prizeGroup.total_begin_quantity.toString().length >
              10 && quantityPrize === QUANTITY_PRIZE.ACTIVE
          }
        >
          <div className="my-rank-name">
            <div className="logo-rank-name">
              <img src={showImageRank(prizeGroup.rank_name)} alt="rank" />
            </div>

            <div
              className={`wrap-title-prize ${setBackGroundLineUp(prizeGroup.rank_name).background}`}
            >
              <div className="wrap-radius-prize"></div>
              <div
                className={`background-border ${
                  setBackGroundLineUp(prizeGroup.rank_name).background
                }`}
              ></div>
              <div className="wrap-border"></div>
              <StyledPrizeLeft>
                <div className="title-prize text-center">
                  {prizeGroup.title}{' '}
                  {t('quantityPrize').replace('param', prizeGroup.quantity_prize)}
                </div>
              </StyledPrizeLeft>
            </div>
          </div>
        </WidthLeft>
        <WidthRight
          isLength={
            prizeGroup.total_quantity.toString().length +
              prizeGroup.total_begin_quantity.toString().length >
              10 && quantityPrize === QUANTITY_PRIZE.ACTIVE
          }
        >
          <div
            className={`line-up-win-rate ${setBackGroundLineUp(prizeGroup.rank_name).background}`}
          >
            <div className="border-left-dotted">
              <img src={dottedLineupHeader} />
            </div>
            <StyledPrizeRight>
              <div className="win-rate-first">
                <div className="text">{t('winRate')}</div>
                <div className="win-rate-value">
                  {parseFloat(prizeGroup.win_rate).toFixed(2)}
                  <span>%</span>
                </div>
              </div>
              {quantityPrize === QUANTITY_PRIZE.ACTIVE && (
                <>
                  <div className="border-left"></div>
                  <div className="win-rate-second">
                    {prizeGroup.total_quantity > 0 ? (
                      <>
                        <div className="text">{t('winRate/100')}</div>
                        <div className="win-rate-value">
                          <StyledSpan length={prizeGroup.total_begin_quantity?.length || 0}>
                            <strong className="f-b">{prizeGroup.total_quantity} </strong>/{' '}
                            {prizeGroup.total_begin_quantity}
                          </StyledSpan>
                        </div>
                      </>
                    ) : (
                      <div className="win-rate-sold-out">SOLD OUT</div>
                    )}
                  </div>
                </>
              )}
              <div className="wrap-radius-prize-right rotate-180"></div>
            </StyledPrizeRight>
          </div>
        </WidthRight>
      </div>
    </div>
  );
}

export default LineUpHeader;
